module.exports = __webpack_public_path__ + "img/file_search_not_found.81a7697b.svg";